<template>
  <div class="glass-sidebar">
    <!-- Top Section -->
    <div class="sb-top">
      <div class="sb-brand">
        <div class="sb-brand-mark">
          {{ userDados?.user ? userDados.user[0].toUpperCase() : "S" }}
        </div>
        <div class="sb-brand-info">
          <div class="sb-user-name">{{ userDados?.user ?? "USERNAME" }}</div>
          <div class="sb-schema">{{ currentSchema ?? "NÃO DEFINIDO" }}</div>
        </div>
        <!--<button
          class="sb-theme-btn"
          @click="toggleTheme"
          :title="theme === 'light' ? 'Modo escuro' : 'Modo claro'"
          aria-label="Alternar tema"
        >
          <i :class="['fas', theme === 'light' ? 'fa-moon' : 'fa-sun']"></i>
        </button>-->
        <button class="sb-menu-btn" @click="dialog_a_show = true" title="Logout">
          <i class="fas fa-sign-out-alt"></i>
        </button>
      </div>

      <!-- Context cards (cliente, subcliente, local) -->
      <div v-if="getPickedCliente || getPickedSubCliente || getPickedLocalInstalacao" class="sb-context">
        <div v-if="getPickedCliente !== null" class="sb-context-card">
          <span class="sb-context-label">Cliente</span>
          <span class="sb-context-value">{{ clienteLabel }}</span>
        </div>

        <div v-if="getPickedSubCliente !== null" class="sb-context-card">
          <span class="sb-context-label">Subcliente</span>
          <div class="sb-context-row">
            <span class="sb-context-value">{{ getPickedSubCliente?.nome ?? "SUBCLIENTE" }}</span>
            <button class="sb-remove-btn" @click="removePickedSubCliente">
              <Icon class="close_icon" icon="mdi:remove" />
            </button>
          </div>
        </div>

        <div v-if="getPickedLocalInstalacao" class="sb-context-card">
          <span class="sb-context-label">Instalações</span>
          <div class="sb-context-row">
            <span class="sb-context-value">
              {{ getPickedLocalInstalacao.localInstalação ?? getPickedLocalInstalacao.nome ?? "LOCAL" }}
            </span>
            <button class="sb-remove-btn" @click="removePickedLocalInstalacao">
              <Icon class="close_icon" icon="mdi:remove" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Nav links -->
    <div class="sb-scroll">
      <div class="sb-nav-stack">
        <router-link
          v-for="(content, index) in filteredSidebarContent"
          :key="index"
          :to="content.route"
          class="sb-link-wrap"
        >
          <div
            v-if="content.visibility"
            class="sb-link"
            :class="{ 'sb-link-active': $route.path === content.route }"
          >
            <span class="sb-link-icon">
              <i :class="content.side_bar_logo"></i>
            </span>
            <span class="sb-link-text">{{ content.side_bar_text }}</span>
          </div>
        </router-link>
      </div>
    </div>
  </div>

  <DialogAction
    v-if="dialog_a_show"
    :propsData="dialog_a_data"
    @close="dialog_a_show = false"
    @confirmReturn="confirmReturn"
  />
</template>

<script>
import axios from "axios";
import permissionMixin from "@/permissionMixin.js";
import { UserData, fullUserData, getUser as logCliente } from "@/extraData";
import { mapGetters, mapMutations } from "vuex";
import DialogAction from "@/components/dialog/actionDialog.vue";
import { useTheme } from "@/composables/useTheme";

export default {
  mixins: [permissionMixin],
  name: "AppSideBar",
  setup() {
    const { theme, toggleTheme } = useTheme();
    return { theme, toggleTheme };
  },
  components: {
    DialogAction,
  },
  data() {
    return {
      currentSchema: "",
      pickedSubCliente: null,

      getPickedCliente: null,
      getPickedSubCliente: null,
      getPickedLocalInstalacao: null,

      UserData: UserData,
      userDados: JSON.parse(localStorage.getItem("user")) ?? null,
      clienteData: logCliente,
      fullUserData: fullUserData,
      baseURL: process.env.VUE_APP_URL_BASE,
      empresaExiste: false,
      hasPickedLocal: true,
      clientesAcessoCount: 0,

      dialog_a_show: false,
      dialog_a_data: {
        title: "Sair",
        message: "Tens a certeza que queres terminar a sessão?",
        confirm: true,
        buttons: [
          {
            text: "Confirmar",
            color: "#1f6a1fc1",
            action: "proceed",
            entity: null,
          },
          {
            text: "Cancelar",
            color: "#a83838",
            action: "cancel",
            entity: null,
          },
        ],
      },
      // hasPickedLocalInstalacao: false,
      side_bar_content: [
        {
          side_bar_logo: "fas fa-tachometer-alt",
          side_bar_text: "Dashboard",
          route: "/dashboard",
          visibility: true,
        },
        {
          side_bar_logo: "fas fa-users",
          side_bar_text: "Sub Cliente",
          route: "/my-subcliente",
          visibility: true,
        },
        {
          side_bar_logo: "fas fa-map-marker-alt",
          side_bar_text: "Instalações",
          route: "/my-local",
          visibility: true,
        },
        /*{
          side_bar_logo: "fas fa-shopping-cart",
          side_bar_text: "Pedidos",
          route: "/my-pedidos",
          visibility: true,
        },*/
        /*{
          side_bar_logo: "fas fa-file-alt",
          side_bar_text: "Propostas",
          route: "/my-propostas",
          visibility: true,
        },*/
        {
          side_bar_logo: "fas fa-calculator",
          side_bar_text: "Orçamentos",
          route: "/my-orcamentos",
          visibility: true,
        },
        /*{
          side_bar_logo: "fas fa-boxes",
          side_bar_text: "Encomendas",
          route: "/my-encomendas",
          visibility: true,
        },*/
        {
          side_bar_logo: "fas fa-tools",
          side_bar_text: "Agendamento",
          route: "/my-agendamentos",
          visibility: true,
        },
        {
          side_bar_logo: "fas fa-chart-bar",
          side_bar_text: "Relatórios",
          route: "/my-relatorios",
          visibility: true,
        },
        {
          side_bar_logo: "fas fa-file-lines",
          side_bar_text: "Relatórios - Arquivo",
          route: "/my-reports-old",
          visibility: true,
        },
        {
          side_bar_logo: "fas fa-file-invoice-dollar",
          side_bar_text: "Faturas",
          route: "/my-faturas",
          visibility: false,
        },
        {
          side_bar_logo: "fas fa-briefcase",
          side_bar_text: "Artigos",
          route: "/my-artigos",
          visibility: true,
        },
        {
          side_bar_logo: "fas fa-tags",
          side_bar_text: "Tabela de preço",
          route: "/my-tabela_preco",
          visibility: true,
        },
        {
          side_bar_logo: "fas fa-phone",
          side_bar_text: "Contato",
          route: "/my-contactos",
          visibility: false,
        },
        {
          side_bar_logo: "fa-regular fa-map",
          side_bar_text: "Plantas",
          route: "/my-plantas",
          visibility: false,
        },
        {
          side_bar_logo: "fa-solid fa-map-location",
          side_bar_text: "Mapas",
          route: "/my-mapas",
          visibility: this.hasPickedLocal,
        },
        {
          side_bar_logo: "fas fa-user-circle",
          side_bar_text: "Perfil",
          route: "/my-perfil",
          visibility: true,
        },
      ],
    };
  },
  computed: {
    filteredSidebarContent() {
      if (!this.empresaExiste) {
        return this.side_bar_content.filter(
          (item) => item.route === "/not-authorized"
        );
      } else {
        return this.side_bar_content.map((item) => {
          if (
            ["/my-plantas", "/my-mapas", "/my-tabela_preco"].includes(
              item.route
            )
          ) {
            item.visibility = this.hasPickedLocalInstalacao;
          }
          return item;
        });
      }
    },

    hasPickedLocalInstalacao() {
      return this.getPickedLocalInstalacao !== null ? true : false;
    },

    // Com acessos a subclientes de clientes diferentes não há um cliente
    // único a mostrar.
    clienteLabel() {
      if (this.clientesAcessoCount > 1) return "Vários Clientes";
      return this.getPickedCliente?.cliente ?? "SEM CLIENTE";
    },
  },

  async mounted() {
    await this.checkEmpresaExistence();
    await this.fetchCurrentSchema();
    await this.fetchClientesAcessoCount();
  },

  methods: {
    // Quantos clientes distintos cobrem os subclientes a que o utilizador
    // tem acesso. Usa o endpoint da área de cliente, que só devolve
    // subclientes ativos de clientes ativos.
    async fetchClientesAcessoCount() {
      const userId = this.userDados?.id ?? 0;
      if (!userId) return;
      try {
        const response = await axios.get(
          `${this.baseURL}/api/v1/localinstalacao/utilizador/${userId}/subclientes/`
        );
        const subclientes = response.data?.data ?? [];
        const clientes = new Set(
          subclientes
            .map((sub) => Number(sub.cliente_id || 0))
            .filter((id) => id > 0)
        );
        this.clientesAcessoCount = clientes.size;
      } catch (error) {
        console.error("Erro ao buscar clientes acessíveis:", error);
      }
    },

    async fetchCurrentSchema() {
      try {
        const response = await axios.get(`${this.baseURL}/api/v1/schema/atual`);
        if (response.data && response.data.schema) {
          this.currentSchema = response.data.schema; // Nome do schema obtido
        } else {
          this.currentSchema = "Schema não encontrado";
        }
      } catch (error) {
        console.error("Erro ao buscar empresa atual:", error);
        this.currentSchema = "Erro ao carregar empresa";
      }
    },

    ...mapMutations(["setPickedSubCliente", "setPickedLocalInstalacao"]),

    removePickedSubCliente() {
      this.setPickedLocalInstalacao(null);
      this.fetchFromLocalStorage();
      this.setPickedSubCliente(null);
      this.pickedSubCliente = null;
      this.removePickedLocalInstalacao();
      try {
        localStorage.removeItem("pickedSubCliente");
      } catch (error) {
        console.error("Erro ao remover o subcliente:", error);
      }
      // this.$store.state.localChanged = !this.$store.state.localChanged;
    },

    removePickedLocalInstalacao() {
      this.setPickedLocalInstalacao(null);
      this.fetchFromLocalStorage();
      this.pickedLocalInstalacao = null;

      try {
        localStorage.removeItem("pickedLocalInstalacao");
      } catch (error) {
        console.error("Erro ao remover o local de instalação:", error);
      }

      this.$store.commit("setLocalChanged", !this.$store.state.localChanged);
    },

    localInstalacaoNome() {
      if (this.getPickedLocalInstalacao) {
        let possibleNames = [
          "nome",
          "local",
          "local_instalacao",
          "instalacao",
          "localInstalacao",
        ];

        if (this.getPickedLocalInstalacao.nome) {
          return this.getPickedLocalInstalacao.nome;
        } else {
          for (let name of possibleNames) {
            if (this.getPickedLocalInstalacao[name]) {
              return this.getPickedLocalInstalacao[name];
            }
          }
        }
      } else {
        return "sem nome";
      }
    },

    async checkEmpresaExistence() {
      try {
        const response = await axios.get(
          `${this.baseURL}/api/v1/empresa/nome/`
        );
        if (response.data && response.data.empresa) {
          this.empresaExiste = true;
        } else {
          this.empresaExiste = false;
        }
      } catch (error) {
        this.empresaExiste = false;
        console.error("Erro ao verificar a existência da empresa:", error);
      }
    },
    validPermission(codigo) {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && user.perfil && user.perfil.permissao) {
        return user.perfil.permissao.some(
          (perm) => perm.codigo === codigo && perm.autorizacao
        );
      }
      return false;
    },

    changeLocalKey() {
      if (this.getPickedLocalInstalacao) {
        if (this.getPickedLocalInstalacao.localInstalação) {
          this.getPickedLocalInstalacao.nome =
            this.getPickedLocalInstalacao.localInstalação;
          delete this.getPickedLocalInstalacao.localInstalação;
        }
      }
    },

    fetchFromLocalStorage() {
      this.getPickedCliente =
        JSON.parse(localStorage.getItem("pickedCliente")) ?? null;
      this.getPickedSubCliente =
        JSON.parse(localStorage.getItem("pickedSubCliente")) ?? null;
      this.getPickedLocalInstalacao =
        JSON.parse(localStorage.getItem("pickedLocalInstalacao")) ?? null;
    },

    async logout() {
      try {
        const res = await axios
          .post(`${this.baseUrl}/api/v1/logout/${this.userDados.id}/`)
          .then((response) => {
            console.log("Logout:", response);
          });
      } catch (error) {
        console.log("Erro ao fazer logout:", error);
      }
      this.$router.push({ name: "signin" });
      localStorage.clear();
    },

    confirmReturn(action) {
      if (action === "proceed") {
        this.logout();
      } else {
        this.dialog_a_show = false;
      }
    },
  },
  watch: {
    "$store.state.localChanged": {
      handler() {
        this.fetchFromLocalStorage();
      },
      immediate: true,
    },

    getPickedLocalInstalacao() {
      // alert('Local Mudou!');
      this.hasPickedLocalInstalacao = this.getPickedLocalInstalacao
        ? true
        : false;
      // console.log('HasPickedLocalInstalacao:', this.hasPickedLocalInstalacao);
      // this.changeLocalKey();
    },
  },

  async created() {
    // console.log('GET Cliente:', this.getPickedCliente);
    // console.log('GET SubCliente:', this.getPickedSubCliente);
    // console.log('GET LocalInstalacao:', this.getPickedLocalInstalacao);
    // window.location.reload();
    // this.changeLocalKey();

    this.getPickedCliente =
      JSON.parse(localStorage.getItem("pickedCliente")) ?? null;
    this.getPickedSubCliente =
      JSON.parse(localStorage.getItem("pickedSubCliente")) ?? null;
    this.getPickedLocalInstalacao =
      JSON.parse(localStorage.getItem("pickedLocalInstalacao")) ?? null;

    this.clienteData = await logCliente;
    //  console.log('CLienteEEEE:', await this.clienteData);
  },
};
</script>

<style scoped>
/* ── Glass Sidebar (Client) ── */
.glass-sidebar {
  position: sticky;
  top: 0;
  height: calc(100vh - 36px);
  width: 260px;
  min-width: 260px;
  border-radius: 26px;
  background:
    radial-gradient(120% 120% at 0% 0%, rgba(138,160,255,.10), transparent 42%),
    radial-gradient(100% 120% at 100% 100%, rgba(126,231,135,.08), transparent 38%),
    linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,.02)),
    linear-gradient(180deg, rgba(16,21,38,.96), rgba(7,10,20,.98));
  border: 1px solid rgba(255,255,255,.14);
  box-shadow: 0 30px 80px rgba(0,0,0,.55);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(16px);
}

.sb-top {
  padding: 16px 14px 12px;
  border-bottom: 1px solid rgba(255,255,255,.10);
  background: rgba(255,255,255,.02);
}

.sb-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 12px;
  border-radius: 18px;
  border: 1px solid rgba(255,255,255,.10);
  background: rgba(255,255,255,.04);
}

.sb-brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-weight: 900;
  font-size: 16px;
  color: #d7fffe;
  background: linear-gradient(180deg, rgba(33,196,184,.26), rgba(33,196,184,.10));
  border: 1px solid rgba(33,196,184,.34);
  flex: 0 0 auto;
}

.sb-brand-info {
  flex: 1;
  min-width: 0;
}

.sb-user-name {
  font-weight: 860;
  font-size: 14px;
  letter-spacing: .2px;
  color: rgba(255,255,255,.96);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
}

.sb-schema {
  margin-top: 3px;
  font-size: 12px;
  color: rgba(255,255,255,.60);
  text-transform: uppercase;
  letter-spacing: .5px;
}

.sb-menu-btn {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,.14);
  background: rgba(255,255,255,.06);
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: .16s ease;
  flex: 0 0 auto;
  color: rgba(255,123,114,.85);
  font-size: 14px;
}

.sb-theme-btn {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,.14);
  background: rgba(255,255,255,.06);
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: .16s ease;
  flex: 0 0 auto;
  color: rgba(255,204,102,.85);
  font-size: 14px;
}
.sb-theme-btn:hover {
  background: rgba(255,204,102,.16);
  border-color: rgba(255,204,102,.34);
}
.sb-menu-btn:hover {
  background: rgba(255,123,114,.14);
  border-color: rgba(255,123,114,.35);
  transform: translateY(-1px);
}

/* ── Context Cards ── */
.sb-context {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.sb-context-card {
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,.10);
  background: rgba(255,255,255,.04);
}

.sb-context-label {
  font-size: 11px;
  color: rgba(255,255,255,.50);
  text-transform: uppercase;
  letter-spacing: .5px;
}

.sb-context-value {
  display: block;
  margin-top: 2px;
  font-size: 13px;
  font-weight: 760;
  color: rgba(255,255,255,.92);
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sb-context-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.sb-remove-btn {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  border: 1px solid rgba(255,123,114,.25);
  background: rgba(255,123,114,.10);
  color: rgba(255,123,114,.85);
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: .15s ease;
  flex: 0 0 auto;
  font-size: 12px;
}
.sb-remove-btn:hover {
  background: rgba(255,123,114,.20);
  border-color: rgba(255,123,114,.45);
}

/* ── Scroll Area ── */
.sb-scroll {
  padding: 12px 10px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(138,160,255,.20) transparent;
}

.sb-scroll::-webkit-scrollbar { width: 4px; }
.sb-scroll::-webkit-scrollbar-track { background: transparent; }
.sb-scroll::-webkit-scrollbar-thumb { background: rgba(138,160,255,.25); border-radius: 999px; }

/* ── Nav Stack ── */
.sb-nav-stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sb-link-wrap { text-decoration: none; }

.sb-link {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  padding: 8px 12px;
  border-radius: 14px;
  border: 1px solid transparent;
  color: rgba(255,255,255,.84);
  transition: all .15s ease;
  font-size: 14px;
}

.sb-link:hover {
  background: rgba(255,255,255,.05);
  border-color: rgba(255,255,255,.10);
  transform: translateY(-1px);
}

.sb-link-active {
  background: rgba(138,160,255,.16) !important;
  border-color: rgba(138,160,255,.34) !important;
  color: rgba(255,255,255,.96);
  box-shadow: inset 0 0 0 1px rgba(255,255,255,.04);
}

.sb-link-icon {
  width: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--icon, #ff9b05);
  opacity: .92;
  flex: 0 0 auto;
  font-size: 14px;
}

.sb-link-text {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}
</style>
